/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import makeRequest, {makeFormDataRequest} from "../../../app/api/makeRequest";
import {useAlert} from 'react-alert'
import {useTranslation} from "react-i18next";

export function DashboardFileMenu({item,onDelete = ()=>{}}) {
    const { t } = useTranslation('common')
    const alert = useAlert()

    const deleteRequest = ()=>{
        const formData = new FormData()
        makeFormDataRequest(`panel/import/file/delete/${item.id}`,formData )
          .then(({data}) => {
            const {success} = data
            if(success) {
                alert.success(t('SuccessfullyRemoved'))
                setTimeout(()=>{
                    onDelete()
                },500)
            }else{
                const {error} = data
                alert.error(error)
            }
        }).catch(() => {
            alert.error(t('Error'))
        })
    }
    return (<>
        {/*begin::Navigation*/}
        <ul className="navi navi-hover">
            <li className="navi-footer py-1 d-block">
                <Link className="btn px-0 font-weight-bold btn-sm d-block" to={`/file/edit/${item.id}`}>
                    <Button variant="outline-info" className="w-100">
                        <i className="far fa-edit"/>
                        {t('Edit')}
                    </Button>

                </Link>
            </li>
            <li className="navi-footer py-1 d-block">
                <Button onClick={deleteRequest} variant="outline-info" className="w-100">
                    <i className="far fa-trash-alt"/>
                    {t('Delete')}
                </Button>
            </li>
        </ul>
        {/*end::Navigation*/}
    </>);
}
